import styled, { css } from 'styled-components/macro'

type OverlayProps = {
  isOpen: boolean
}
export const StyledBackground = styled.div<OverlayProps>`
  ${({ isOpen }) =>
    !isOpen &&
    css`
      display: none;
    `}
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
  background-color: black;
  opacity: 0.2;
  z-index: 1;
`

